export const GRADING_FEE_MODES = {
  VALUE: 'value',
  STANDARD: 'standard',
  PRIORITY: 'priority',
  EXPRESS: 'express'
};

export const DEFAULT_GRADING_FEE_MODE = GRADING_FEE_MODES.VALUE;

export const GRADING_FEE_MODE_LABELS = {
  [GRADING_FEE_MODES.VALUE]: '$40 Grading Fee',
  [GRADING_FEE_MODES.STANDARD]: '$60 Grading Fee',
  [GRADING_FEE_MODES.PRIORITY]: '$80 Grading Fee',
  [GRADING_FEE_MODES.EXPRESS]: '$199 Grading Fee'
};

export const normalizeGradingFeeMode = (mode) => {
  const normalizedMode = String(mode || '').toLowerCase();
  if (normalizedMode === GRADING_FEE_MODES.STANDARD) {
    return GRADING_FEE_MODES.STANDARD;
  }
  if ([GRADING_FEE_MODES.PRIORITY, 'temp_80', 'psa80'].includes(normalizedMode)) {
    return GRADING_FEE_MODES.PRIORITY;
  }
  if ([GRADING_FEE_MODES.EXPRESS, 'temp_150', 'psa150'].includes(normalizedMode)) {
    return GRADING_FEE_MODES.EXPRESS;
  }
  return DEFAULT_GRADING_FEE_MODE;
};

export const shouldShowExpressCoinScoreWarning = (mode, coinScore) => {
  if (coinScore === null || coinScore === undefined || coinScore === '') return false;
  const normalizedScore = Number(coinScore);
  return normalizeGradingFeeMode(mode) === GRADING_FEE_MODES.EXPRESS
    && Number.isFinite(normalizedScore)
    && normalizedScore < 1.25;
};
